import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const ITEMS = [
  {
    n: "01",
    title: "Implementering",
    text: "Når traumebevidsthed skal forankres i organisationens praksis, relationer og rammer.",
    id: "implementering",
  },
  {
    n: "02",
    title: "Kurser",
    text: "Viden og handlegreb til at styrke praksis",
    id: "kurser",
  },
  {
    n: "03",
    title: "Supervision",
    text: "Et rum for refleksion, forståelse og udvikling af faglig praksis.",
    id: "supervision",
  },
];

const Offerings = () => (
  <section id="tilbud" data-testid="offerings-section" className="scroll-mt-24 px-6 py-28 lg:py-40">
    <div className="mx-auto max-w-5xl">
      <Reveal className="max-w-2xl">
        <h2 className="font-serif text-3xl text-[#3F5A47] sm:text-4xl lg:text-5xl">
          Fra forståelse til praksis
        </h2>
        <p className="mt-7 text-base leading-relaxed text-[#2F3338]/85">
          Vi understøtter fagpersoner og organisationer i at omsætte traumebevidst
          viden til praksis – og i at skabe betingelser, hvor udvikling kan slå rod.
        </p>
      </Reveal>
      <div className="mt-16 grid gap-14 sm:grid-cols-2 lg:mt-24 lg:gap-x-24">
        {ITEMS.map((item, i) => (
          <Reveal key={item.id} delay={i * 0.08} className={i % 2 === 1 ? "lg:translate-y-14" : ""}>
            <article
              data-testid={`offering-item-${item.id}`}
              className="group border-t border-[#D6C2A6]/70 pt-8"
            >
              <h3 className="font-serif text-2xl text-[#2F3338] sm:text-3xl">{item.title}</h3>
              <p className="mt-4 max-w-sm text-base leading-relaxed text-[#2F3338]/80">{item.text}</p>
              <Link
                to={`/vi-tilbyder/${item.id}`}
                data-testid={`offering-link-${item.id}`}
                className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-[#3F5A47] transition-colors duration-300 hover:text-[#B46A45]"
              >
                Læs mere
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Offerings;
